import {
  createStyles,
  Group,
  GroupProps,
  Stack,
  StackProps,
  Text,
} from '@mantine/core';
import React, { ReactNode } from 'react';

export interface DetailsListProps {
  title?: ReactNode;
  items: Array<{ label: ReactNode; value: ReactNode }>;
  groupProps?: GroupProps;
  stackProps?: StackProps;
}

export function DetailsList({
  title,
  items,
  groupProps = {},
  stackProps = {},
}: DetailsListProps) {
  const { classes } = useStyles();

  return (
    <Stack data-testid="details-list" {...stackProps}>
      {title && <Text className={classes.title}>{title}</Text>}

      <Stack spacing="sm">
        {items.map(({ label, value }, index) => (
          <Group key={index} position="apart" align="start" {...groupProps}>
            <Text inherit className={classes.label}>
              {label}
            </Text>

            <Text
              inherit
              data-testid={`${label}-value`}
              className={classes.value}
              truncate
            >
              {value}
            </Text>
          </Group>
        ))}
      </Stack>
    </Stack>
  );
}

const useStyles = createStyles((theme) => ({
  title: {
    fontSize: theme.fontSizes.md,
    fontWeight: 600,
    color: theme.colors.gray[7],
  },
  label: {
    color: theme.colors.gray[5],
  },
  value: {
    color: theme.colors.blue_gray[9],
  },
}));
